/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    a: "a",
    pre: "pre",
    blockquote: "blockquote"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "ThemeConsumer"
      }), "(", _jsx(_components.code, {
        children: "ThemeConsumer"
      }), ")"]
    }), "\n", _jsx(_components.p, {
      children: "| v4"
    }), "\n", _jsxs(_components.p, {
      children: ["这是 ", _jsx(_components.code, {
        children: "React.createContext"
      }), " 创建的 ", _jsx(_components.a, {
        href: "https://react.nodejs.cn/docs/context.html#consumer",
        children: "\"consumer\" 组件"
      }), "，作为 ", _jsx(_components.code, {
        children: "ThemeProvider"
      }), " 的配套组件。它使用 ", _jsx(_components.a, {
        href: "https://react.nodejs.cn/docs/render-props.html",
        children: "渲染属性模式"
      }), " 允许在渲染期间动态访问主题。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is the ", _jsx(_components.a, {
        href: "https://react.nodejs.cn/docs/context.html#consumer",
        children: "\"consumer\" component"
      }), " created by ", _jsx(_components.code, {
        children: "React.createContext"
      }), " as the companion component to ", _jsx(_components.code, {
        children: "ThemeProvider"
      }), ". It uses the ", _jsx(_components.a, {
        href: "https://react.nodejs.cn/docs/render-props.html",
        children: "render prop pattern"
      }), " to allow for dynamic access to the theme during rendering."]
    }), "\n", _jsxs(_components.p, {
      children: ["它将当前主题（基于组件树中更高的 ", _jsx(_components.a, {
        href: "/docs/api#themeprovider",
        children: _jsx(_components.code, {
          children: "ThemeProvider"
        })
      }), "）作为参数传递给子函数。从此函数中，你可能会返回更多 JSX，也可能什么也不返回。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥It passes the current theme (based on a ", _jsx(_components.a, {
        href: "/docs/api#themeprovider",
        children: _jsx(_components.code, {
          children: "ThemeProvider"
        })
      }), " higher in your component tree) as an argument to the child function. From this function, you may return further JSX or nothing."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { ThemeConsumer } from 'styled-components'\n\nexport default class MyComponent extends React.Component {\n  render() {\n    return (\n      <ThemeConsumer>\n        {theme => <div>The theme color is {theme.color}.</div>}\n      </ThemeConsumer>\n    )\n  }\n}\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["所有样式组件 ", _jsx(_components.a, {
          href: "/docs/advanced#theming",
          children: "自动接收主题作为属性"
        }), "，因此仅当你出于其他原因希望访问主题时才需要这样做。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥All styled components ", _jsx(_components.a, {
          href: "/docs/advanced#theming",
          children: "automatically receive the theme as a prop"
        }), ", so this is only necessary if you wish to access the theme for other reasons."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
